"use strict";
exports.__esModule = true;
exports.AUTOCOMPUTE_DURATION = "AUTOCOMPUTE_DURATION";
exports.EXTENDED_DATA_MAX_ENTRIES = 15;
exports.GTL_UTC_FIELD_NAME_CORRELATION_VECTOR = "__TlgCV__";
exports.GTL_CLICKSTREAM_PAGEVIEW_PARTB_VER = "gtl.pageview.1";
exports.GTL_CLICKSTREAM_PAGEACTION_PARTB_VER = "gtl.pageaction.1";
exports.GTL_CLICKSTREAM_CONTENTUPDATE_PARTB_VER = "gtl.contentupdate.1";
exports.GTL_RELATEDCV_PARTB_VER = "gtl.relatedcv.1";
exports.GTL_APPACTION_PARTB_VER = "gtl.appaction.1";
exports.GTL_APPLAUNCH_PARTB_VER = "gtl.applaunch.1";
exports.GTL_SHARED_INSTRUMENTATION_KEY = "35f4cb70756c44b8a5350a0edb04b7e6-8b52f951-3d1a-4b44-b3d4-cd0490e8d81a-7361";
exports.INT64_MAX = 9223372036854775807;
//# sourceMappingURL=Constants.js.map